import {
    DateTime
} from 'luxon';
import TimeRange from '../getTimeRange';
const numeral = require('numeral');
const dateTimeHashMap = new TimeRange().dateTimeHashMap;

export default function dataSourceGenerator(rawData, timeSelectorValue, theme) {
    let startDate = dateTimeHashMap[timeSelectorValue]['startDate'],
        endDate = dateTimeHashMap[timeSelectorValue]['endDate'],
        startDateInDateTime = DateTime.fromFormat(startDate, 'M/d/yy H:mm'),
        endDateInDateTime = DateTime.fromFormat(endDate, 'M/d/yy H:mm'),
        diffInDays = Math.floor(endDateInDateTime.diff(startDateInDateTime, 'days').values.days),
    billAmount = new Array(diffInDays + 1).fill(0),
        grossBillAmount = 0;
    for (let i = 0; i < rawData.length; i++) {
        let numberOfDaysFromStart = Math.floor(DateTime.fromMillis(rawData[i]['expectedShipDate'], 'M/d/yy H:mm').diff(startDateInDateTime, 'days').values.days);
        billAmount[numberOfDaysFromStart] += parseFloat(rawData[i]['billAmount'].replace(/,/g, ''));
    }
    for (let j = 1; j < billAmount.length; j++) {
        if (billAmount[j]) {
        grossBillAmount += billAmount[j]
        }
    }
    if (grossBillAmount) {
    return numeral(grossBillAmount.toFixed(0)).format('$0,0');
    }
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/billAmountText.js